import React from 'react'
import { Redirect } from 'react-router'
import { stringify } from 'query-string'

import { RouteProps, routes, useQueryParams } from '@sketch/modules-common'

// Hooks
import useUserProfile from 'modules/user/useUserProfile'

// Local Components
import CommunityListingPage from '../containers/CommunityListingPage'
import CommunityHeader from '../components/CommunityHeader'

const CommunityListingView = (
  props: RouteProps<'COMMUNITY_CANVAS_LISTING'>
) => {
  const { match } = props
  const { listIdentifier } = match.params

  const { search } = useQueryParams<'COMMUNITY_CANVAS_LISTING'>()
  const { data: userData } = useUserProfile()
  const user = userData?.me

  if (search) {
    return (
      <Redirect
        to={{
          pathname: routes.COMMUNITY_CANVAS.create({}),
          search: stringify({ search }),
        }}
      />
    )
  }

  return (
    <>
      <CommunityHeader user={user} />
      <CommunityListingPage listIdentifier={listIdentifier} />
    </>
  )
}

export default CommunityListingView
